<div class="basicarticle-admin">
  <sc-padding [fitHeight]="true">
    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true">
        <sc-title>
            {{ 'Basisartikel' | translate: ['erp.ui.basicarticle.title', translationService.language]}}
            <sc-content-spacer></sc-content-spacer>
            <button mat-stroked-button (click)="onCreateNewBasicArticle()" [disabled]="selectedArticleType == null">
                <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                {{ 'Neuer Basisartikel' | translate: ['erp.ui.basicarticle.action.new', translationService.language]}}
            </button>
        </sc-title>

        <sc-content-spacer [vertical]="true"></sc-content-spacer>

        <sc-bordered-tile>
          <sc-padding>
            <form [formGroup]="formGroup" class="no-field-space">
              <!-- Select Box mit allen ArticleTypes -->
              <mat-form-field appearance="fill">
                <mat-label>{{ 'ArticleType' | translate: ['erp.entity.articletype.name', translationService.language]}}</mat-label>
                <mat-select formControlName="articleTypeControl" [value]="selectedArticleType">
                    <mat-option *ngFor="let source of articleTypes" [value]="source">
                        {{source.title}}
                    </mat-option>
                </mat-select>
              </mat-form-field>
            </form>
          </sc-padding>
        </sc-bordered-tile>

        <sc-content-spacer [vertical]="true" [double]="true"></sc-content-spacer>

        <sc-flex-fitting-content [vertical]="true">
          <sc-scroll-pane>
            <sc-bordered-tile *ngIf="datasource.data.length > 0">
              <sc-padding>
                <!-- Table mit BasicArticles -->
                <div class="basicarticles">
                  <table mat-table [dataSource]="datasource" matSort (matSortChange)="announceSortChange($event)">

                      <ng-container *ngFor="let disCol of columnNames; let colIndex = index" matColumnDef="{{disCol}}">
                        <ng-container *ngIf="disCol != 'actions'">
                          <th mat-header-cell *matHeaderCellDef>{{disCol}}</th>
                          <td mat-cell *matCellDef="let element" class="text-selection"> {{element[disCol]}} </td>
                        </ng-container>
                        <ng-container *ngIf="disCol == 'actions'">
                          <th mat-header-cell *matHeaderCellDef></th>
                          <td mat-cell *matCellDef="let element">
                            <button mat-icon-button (click)="editBasicArticle(element.basicArticle)"><sc-icon iconClass="fa-pencil"></sc-icon></button>
                          </td>
                        </ng-container>

                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
                      <tr mat-row *matRowDef="let row; columns: columnNames;"></tr>
                  </table>
                </div>
              </sc-padding>
            </sc-bordered-tile>

          </sc-scroll-pane>
        </sc-flex-fitting-content>

    </sc-flex>
  </sc-padding>
</div>
